<template>
  <v-text-field
    ref="input"
    :value="formattedValue"
    type="text"
    :label="label"
    :rules="rules"
    :suffix="suffix"
    @change="change"
  />
</template>

<script>
import { format, unformat } from '@/plugins/moneyFormat'

export default {
   name: 'MoneyField',
   props: {
      value: {
         required: true,
         type: [Number, String],
         default: 0,
      },
      masked: {
         type: Boolean,
         default: false,
      },
      precision: {
         type: Number,
         default: () => 2,
      },
      decimal: {
         type: String,
         default: () => ',',
      },
      thousands: {
         type: String,
         default: () => '.',
      },
      prefix: {
         type: String,
         default: () => '',
      },
      suffix: {
         type: String,
         default: () => '€',
      },
      label: {
         type: String,
         default: () => 'MoneyInput',
      },
   },
   data () {
      return {
         rules: [
            (v) => new RegExp(`^-?[\\d{1,3}(?:\\${this.thousands}\\d{3})|\\d]*\\${this.decimal}\\d*$`).test(v) || `Bitte ${this.decimal} einfügen.`,
            (v) => new RegExp(`^-?[\\d{1,3}(?:\\${this.thousands}\\d{3})|\\d]*\\${this.decimal}\\d{${this.precision}}$`).test(v) || `${this.precision} Nachkommastellen benötigt`,
         ],
         formattedValue: null,
      }
   },
   watch: {
      value: {
         immediate: true,
         handler (newValue, oldValue) {
            const formatted = format(newValue, this.$props)
            if (formatted !== this.formattedValue) {
               this.formattedValue = formatted
            }
         },
      },
   },
   methods: {
      change (input) {
         if (this.$refs.input.valid) {
            input = format(input, this.$props)
            this.$emit('input', unformat(input, this.precision))
         }
      },
   },
}
</script>
<style>
/* .v-text-field--outlined .v-label {
      font-size: 20px;
   }
   .v-text-field--outlined.v-input--dense .v-label--active {
      transform: translateY(-18px) scale(0.75);
   }
   .v-text-field--outlined input {
      outline: none;
   } */
</style>
